export default __webpack_public_path__ + "static/equipo-gabi-Color-Grande-2db942ce4bc1856acf915b7ba53e7658.png";